import Backbone from 'backbone';
import config from 'config';
import {
    getInternalWebsiteBaseUrl as _getInternalWebsiteBaseUrl,
    getPublicWebsiteBaseUrl as _getPublicWebsiteBaseUrl,
    isBizzaboInternalWebsiteWhiteLabeled
} from 'web-common/scripts/utils/whitelabelUtils';

const Event = Backbone.Model.extend({

    url: function() {
        return '/api/v1/event/' + this.id;
    },

    parse: function(response, options) {
        return response.event || response;
    },

    getLandingPageUrl: function() {
        return this.getPublicWebsiteBaseUrl() + '?share=true';
    },

    getInternalWebsiteBaseUrl: function(path){
        return _getInternalWebsiteBaseUrl(this.toJSON(), path);
    },

    getInternalAgendaUrl: function() {
        return this.getInternalWebsiteBaseUrl('/agenda');
    },

    getPublicWebsiteBaseUrl: function(path) {
        return _getPublicWebsiteBaseUrl(this.toJSON(), path);
    },

    getUrlPrefix: function() {

        if (isBizzaboInternalWebsiteWhiteLabeled(this.toJSON())) {
            if (!this.get('onlyEventDomain')){
                return this.get('whitelabelPath');
            }
            return '';
        }
        const uniqueName = this.get('unique-name');

        return '/' + uniqueName;
    },

    getAgendaUrl: function() {
        const type = this.get('websiteType');
        const agendaUrl = this.get('agendaUrl');
        if (type === 'independent') {
            const independentUrl = this.get('independentUrl');
            return agendaUrl ? agendaUrl : independentUrl;
        }
        return agendaUrl ? agendaUrl : this.getInternalAgendaUrl();
    },

    getCommunityUrl: function() {
        const type = this.get('websiteType');
        const communityUrl = this.get('communityUrl');
        if (type === 'independent') {
            const independentUrl = this.get('independentUrl');
            return communityUrl ? communityUrl : independentUrl;
        }
        return communityUrl ? communityUrl : this.getInternalWebsiteBaseUrl('/community') ;
    },

    getAgendaSessionUrl: function(sessionId) {
        const type = this.get('websiteType');
        const baseUrl = this.getAgendaUrl();
        if (type === 'independent') {
            return baseUrl + '?agendaPath=session/' + sessionId;
        } else {
            return baseUrl + '/session/' + sessionId;
        }
    },

    reportSocialShare: function(scenario, providers, options) {
        options = options || {};
        const data = {
            eventId: this.id,
            providers,
            shareScenario: scenario
        };

        Backbone.ajax({
            url: `${config.baseV2Url}/userProfile/socialNetwork/socialShare`,
            method: 'POST',
            data: data,
            success: options.success,
            error: options.error
        });
    },

    shareOnLinkedin: function(scenario, message, options) {
        options = options || {};
        const thisModel = this;
        const linkedinUrl = 'https://api.linkedin.com/v1/people/~/shares';
        const submittedImageUrl = ((this.get('logo-set') && this.get('logo-set').large) || 'http://s3.amazonaws.com/bizzabo.qa.resources/client/share/linkedin-share-image.jpg');
        const data = {
            content: {
                title: (this.get('name') || ''),
                description: (this.get('description') || ''),
                'submitted-url': (this.get('landing-page-url') || 'http://www.bizzabo.com/'),
                'submitted-image-url': submittedImageUrl
            },
            visibility: {
                code: 'anyone'
            },
            comment: message
        };

        const success = options.success;
        options.success = function() {
            thisModel.reportSocialShare(scenario, ['linkedin']);
            success && success();
        };

        Backbone.ajax({
            url: '/api/v2/userProfile/socialNetwork/linkedin/post?url=' + encodeURIComponent(linkedinUrl),
            method: 'POST',
            data: data,
            success: options.success,
            error: options.error
        });
    },

    isJoined: function() {
        return (this.get('attending-status') == 'rsvp') || (this.get('attending-status') == 'checkedin') ? true : false;
    },

    isPrivate: function() {
        return (this.get('privacy') === 'private');
    },

    isPrivateCommunity: function() {
        return (this.get('privacy') === 'private-community');
    },

    isJoinRequired: function() {
        return (this.isPrivate() && !this.isJoined());
    },

    shareOnTwitter: function(scenario, message) {
        const thisModel = this;

        const success = () => {
            thisModel.reportSocialShare(scenario, ['twitter']);
            Backbone.trigger('analytics:SentTweet', 'Join');
        };
        const error = (e) => {
            console.log(e);
        };

        Backbone.ajax({
            url: '/api/v2/userProfile/socialNetwork/twitter/status',
            method: 'POST',
            data: {
                status: message
            },
            success: success,
            error: error
        });
    }

});

export default Event;

